import React from 'react'
import ScrollToTop from '../components/ScrollToTop'
import SignUp from '../components/Signup'

const SignUpPage = () => {
    return (
        <div>
            <ScrollToTop />
            <SignUp />
        </div>
    )
}

export default SignUpPage